var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandHoldingHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4419 80.298C89.7839 72.6396 108.976 52.1146 108.976 38.1027C108.976 25.6189 98.3261 15.498 85.1901 15.498C76.3672 15.498 68.6812 20.0762 64.5758 26.8576C60.4704 20.0762 52.7844 15.498 43.9615 15.498C30.8254 15.498 20.1758 25.6189 20.1758 38.1027C20.1758 48.1889 30.1214 61.6522 39.5532 71.2592",
    fill: "#E4C1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2002 87.0541L16.2297 82.4863L31.2916 106.905L22.0483 112.601",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2002 84.4778L17.2725 79.4492L34.0737 106.331L23.763 112.601",
    stroke: "#081E54",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8841 82.8179L71.027 82.8062C74.7351 82.8062 77.7408 79.8004 77.7408 76.0907C77.7408 72.3827 74.7351 69.377 71.027 69.377L45.3414 69.3887C42.3692 69.3887 39.4492 70.1784 36.8836 71.6754L20.6604 81.1395",
    fill: "#E7EDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8841 82.8179L71.027 82.8062C74.7351 82.8062 77.7408 79.8004 77.7408 76.0907C77.7408 72.3827 74.7351 69.377 71.027 69.377L45.3414 69.3887C42.3692 69.3887 39.4492 70.1784 36.8836 71.6754L20.6604 81.1395",
    stroke: "#081E54",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7176 82.7967L102.086 69.9102C105.502 68.4938 109.452 70.132 110.866 73.546C112.281 76.9616 110.645 80.9133 107.231 82.3279L77.5396 96.5871C75.468 97.4641 73.2385 97.9178 70.9871 97.9178H44.6008C42.7745 97.9178 40.9818 98.4134 39.4176 99.3526L33.4163 102.956",
    fill: "#E7EDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7176 82.7967L102.086 69.9102C105.502 68.4938 109.452 70.132 110.866 73.546C112.281 76.9616 110.645 80.9133 107.231 82.3279L77.5396 96.5871C75.468 97.4641 73.2385 97.9178 70.9871 97.9178H44.6008C42.7745 97.9178 40.9818 98.4134 39.4176 99.3526L33.4163 102.956",
    stroke: "#081E54",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0757 79.4463C91.0335 70.908 111.368 48.0247 111.368 32.403C111.368 18.4849 100.084 7.20117 86.1662 7.20117C76.818 7.20117 68.6744 12.3054 64.3246 19.8659C59.9748 12.3054 51.8312 7.20117 42.4831 7.20117C28.5649 7.20117 17.2812 18.4849 17.2812 32.403C17.2812 43.648 27.819 58.6582 37.8123 69.369",
    stroke: "#081E54",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHoldingHeartIcon);
export default __webpack_public_path__ + "static/media/HandHoldingHeartIcon.418bd108b84b09bb195a84b125091a74.svg";
export { ForwardRef as ReactComponent };